<template>
    <div class="complaints mt-4">
        <b-row>
            <b-col col lg="12" md="12" sm="12">
                <b-form-group
                        vertical
                        :label-cols="2"
                        breakpoint="lg"
                        label="Primary Complaints">
                    <b-form-textarea v-validate="'required'" data-vv-as="Primary Complaints" name="primary_complaints"
                                     @input="dataSetter($event, 'primary_complaints')" :rows="3"
                                     v-model="appointment.primary_complaints"></b-form-textarea>
                    <span class="error">{{ errors.first('primary_complaints') }}</span>
                </b-form-group>
                <b-form-group
                        vertical
                        :label-cols="2"
                        breakpoint="lg"
                        label="History of Illness">
                    <b-form-textarea v-validate="'required'" data-vv-as="Illness History" name="illness_history"
                                     @input="dataSetter($event, 'illness_history')" :rows="6"
                                     v-model="appointment.illness_history"></b-form-textarea>
                    <span class="error">{{ errors.first('illness_history') }}</span>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import FormDataSetter from '@/mixins/form-data-setter';

  export default {
    inject: ['$validator'],
    props: {
      appointment: {
        type: Object
      }
    },
    mixins: [FormDataSetter]
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Form/ComplaintsTab.vue